import { render, staticRenderFns } from "./GenerateN2.vue?vue&type=template&id=662721d3&scoped=true"
import script from "./GenerateN2.vue?vue&type=script&lang=js"
export * from "./GenerateN2.vue?vue&type=script&lang=js"
import style0 from "./GenerateN2.vue?vue&type=style&index=0&id=662721d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662721d3",
  null
  
)

export default component.exports